<template>
    <div class="attendance-setting float-right" >
        <i class="fas fa-cog" @click="checkActive"></i>
        <div class="custom-drop-down attenadance-setting-dropdown " :class="{active: isActive}">
            <h2 class="mb-4"> Attendance Settings </h2>
            <div class="attenadance-setting-dropdown-content">
                <div class="row mb-2">
                    <div class="col-sm-8 col-md-8 col-lg-8">
                        <div class="row align-items-center">
                            <div class="col-sm-3 pr-0">
                                <label class="label block-label m-0"> Start Time </label>
                            </div>
                            <div class="col-sm-9 pl-0">
                                <div class="row normal-ib-space">
                                    <div class="col-sm-4 col-md-4 col-lg-4">
                                        <select class="selectpicker custom-select2" data-size="5" name="start_hrs"  @change="updateAttendanceSetting($event);">
                                            <option v-for="start_time_hour in 12" :value="start_time_hour" :selected="start_time_hour == attendance.companySetting.start_hrs"> {{(start_time_hour < 10) ? '0'+start_time_hour : start_time_hour}} </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-4 col-lg-4">
                                        <select class="selectpicker custom-select2" data-size="5" name="start_mins"  @change="updateAttendanceSetting($event);">
                                            <option v-for="(start_time_minute,index) in 60" :value="index" :selected="index == attendance.companySetting.start_mins"> {{(index < 10) ? '0'+index : index}} </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-4 col-lg-4">
                                        <select class="selectpicker custom-select2" data-size="5" name="start_ampm"  @change="updateAttendanceSetting($event);">
                                            <option value="AM" :selected="'AM' == attendance.companySetting.start_ampm"> AM </option>
                                            <option value="PM" :selected="'PM' == attendance.companySetting.start_ampm"> PM </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 pl-0">
                        <div class="row align-items-center normal-ib-space">
                            <div class="col-sm-4">
                                <label class="label block-label m-0"> Grace </label>
                            </div>
                            <div class="col-sm-4 pl-0 pr-0">
                                <select class="selectpicker custom-select2" data-size="5" name="start_grace_mins" @change="updateAttendanceSetting($event);">
                                    <option v-for="(grace_start_minute,index) in 60" :value="index" :selected="index == attendance.companySetting.start_grace_mins"> {{(index < 10) ? '0'+index : index}} </option>
                                </select>
                            </div>
                            <div class="col-sm-4">
                                <label class="label block-label m-0"> Mins </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-sm-8 col-md-8 col-lg-8">
                        <div class="row align-items-center">
                            <div class="col-sm-3 pr-0">
                                <label class="label block-label m-0"> End Time </label>
                            </div>
                            <div class="col-sm-9 pl-0">
                                <div class="row normal-ib-space">
                                    <div class="col-sm-4 col-md-4 col-lg-4">
                                        <select class="selectpicker custom-select2" data-size="5" name="end_hrs" @change="updateAttendanceSetting($event);">
                                            <option v-for="end_time_hour in 12" :value="end_time_hour" :selected="end_time_hour == attendance.companySetting.end_hrs"> {{(end_time_hour < 10) ? '0'+end_time_hour : end_time_hour}} </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-4 col-lg-4">
                                        <select class="selectpicker custom-select2" data-size="5" name="end_mins" @change="updateAttendanceSetting($event);">
                                            <option v-for="(end_time_minute,index) in 60" :value="index" :selected="index == attendance.companySetting.end_mins"> {{(index < 10) ? '0'+index : index}} </option>
                                        </select>
                                    </div>
                                    <div class="col-sm-4 col-md-4 col-lg-4">
                                        <select class="selectpicker custom-select2" data-size="5" name="end_ampm" @change="updateAttendanceSetting($event);">
                                            <option value="AM" :selected="'AM' == attendance.companySetting.end_ampm"> AM </option>
                                            <option value="PM" :selected="'PM' == attendance.companySetting.end_ampm"> PM </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 pl-0">
                        <div class="row align-items-center normal-ib-space">
                            <div class="col-sm-4">
                                <label class="label block-label m-0"> Grace </label>
                            </div>
                            <div class="col-sm-4 pl-0 pr-0">
                                <select class="selectpicker custom-select2" data-size="5" name="end_grace_mins" @change="updateAttendanceSetting($event);">
                                    <option v-for="(grace_end_minute,index) in 60" :value="index" :selected="index == attendance.companySetting.end_grace_mins"> {{(index < 10) ? '0'+index : index}} </option>
                                </select>
                            </div>
                            <div class="col-sm-4">
                                <label class="label block-label m-0"> Mins </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-2">
                    <div class="col-sm-8 col-md-8 col-lg-8">
                        <div class="row align-items-center">
                            <div class="col-sm-3 pr-0">
                                <label class="label block-label m-0"> Hours Reqd </label>
                            </div>
                            <div class="col-sm-9 pl-0">
                                <div class="row normal-ib-space">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <select class="selectpicker custom-select2" data-size="5" name="hrs_required" @change="updateAttendanceSetting($event);">
                                            <option v-for="req_hr in required_hours" :value="req_hr" :selected="req_hr == attendance.companySetting.hrs_required"> {{req_hr}} </option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-sm-4 col-md-4 col-lg-4 pl-0">
                        <div class="row align-items-center normal-ib-space">
                            <div class="col-sm-4">
                                <label class="label block-label m-0"> Grace </label>
                            </div>
                            <div class="col-sm-4 pl-0 pr-0">
                                <select class="selectpicker custom-select2" data-size="5" name="hrs_required_grace_mins" @change="updateAttendanceSetting($event);">
                                    <option v-for="(hrs_required_grace,index) in 60" :value="index" :selected="index == attendance.companySetting.hrs_required_grace_mins"> {{(index < 10) ? '0'+index : index}} </option>
                                </select>
                            </div>
                            <div class="col-sm-4">
                                <label class="label block-label m-0"> Mins </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3 mt-3">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <div class="row align-items-center">
                            <div class="col-sm-2 pr-0">
                                <label class="label block-label m-0"> Off Days </label>
                            </div>
                            <div class="col-sm-10 pl-0">
                                <div class="row normal-ib-space">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <label class="check-holder" v-for="day in days" :key="day.key">
                                            {{day.key}}
                                            <input type="checkbox" v-model="form.selected_days" :value="day.value" :id="`${day.value}`" @click="checkDays(day.value)">
                                            <span class="checkmark"></span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3 mt-3">
                    <div class="col-sm-12 col-md-12 col-lg-12">
                        <div class="row align-items-center">
                            <div class="col-sm-2 pr-0">
                                <label class="label block-label m-0"> Holidays </label>
                            </div>
                            <div class="col-sm-10 pl-0">
                                <div class="row normal-ib-space">
                                    <div class="col-sm-12 col-md-12 col-lg-12">
                                        <label class="form-control holidays-field txt-transparent ic-calender-purple hasDatepicker" value="Add" @click="triggerDate()">Add</label>
                                        <datepicker name="holiday_date" :disabled-dates="disabledDates" v-model="form.holiday_date" class="holidays-field-value" :bootstrap-styling="true" id="selectedDateHolyDay" ></datepicker>
                                        <!-- <input type="text" class="form-control holidays-field-value hidden"  id="selectedDateHolyDay" placeholder="Tue,22, Oct, 2019"  /> -->
                                        <button class="btnAddHoliday" @click="addHoliday"><span class="fa fa-check" ></span></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row justify-content-end mb-3 mt-3">
                    <div class="col-sm-10 pl-0">
                        <div class="added-holidays clearfix">
                            <div class="holiday-box" v-for="hday in attendance.companyHolidays" :key="hday.id">
                                <span> {{hday.holiday | dateFormate}} </span>
                                <i class="fa fa-times" @click="deteleHoliday(hday.id)"></i>
                            </div>

                        </div>
                    </div>
                </div>
                <div class="row mb-3 mt-3">
                  <div class="col-sm-12 col-md-12 col-lg-12">
                    <div class="row align-items-center">
                      <div class="col-sm-3 pr-0">
                        <label class="label block-label m-0"> Mandatory Selfie </label>
                      </div>
                      <div class="col-sm-9 pl-0">
                        <div class="row">
                          <div class="col-sm-12 col-md-12 col-lg-12">
                            <label class="check-holder">
                              <input type="checkbox" v-model="form.take_selfie" :value="'take_selfie'" :id="`take_selfie`" @click="takeSelfie($event)">
                              <span class="checkmark"></span>
                            </label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        name: "companySetttings",
        data() {
            return {
                required_hours : ['6','6.5','7','7.5','8','8.5','9','9.5','10','10.5','11','11.5','12'],
                isActive: false,
                formObj: {
                    key : '',
                    value : ''
                },
                days: [
                    {   'key':'Mon', 'value':'Monday'},
                    {   'key':'Tue', 'value':'Tuesday'},
                    {   'key':'Wed', 'value':'Wednesday'},
                    {   'key':'Thu', 'value':'Thursday'},
                    {   'key':'Fri', 'value':'Friday'},
                    {   'key':'Sat', 'value':'Saturday'},
                    {   'key':'Sun', 'value':'Sunday'},
                    ],
                form: new Form({
                    holiday_date : new Date(),
                    selected_days: [],
                    take_selfie: ''
                }),
                disabledDates: {
                    days: [],
                    dates: [
                        // new Date(2020, 1, 5),
                        // new Date(2020, 1, 12)
                    ],
                },
                attendance :{
                    companySetting:{
                        start_hrs:'',
                    }
                }
            };
        },
        filters: {
            dateFormate: function(date){
                return moment(date).format('ddd,DD, MMM, YYYY');
            }
        },
        mounted: function() {
            EventBus.$on('attendanceObject', data => {
                this.attendance = data;
                console.log(this.attendance);
                this.get_single_day();
            });
        },
        created() {
        },
        methods: {
            get_single_day(){
                let vm = this;
                vm.disabledDates.days = [];
                var str = this.attendance.companySetting.off_days;
                if(str !== null){
                    vm.form.selected_days = [];
                    var obj = JSON.parse(str);
                    Object.keys(obj).forEach(function(key) {
                        vm.form.selected_days.push(obj[key]);
                        //code for disabled holidays days dates
                        if(obj[key] == "Sunday"){
                            vm.disabledDates.days.push(0);
                        }else if(obj[key] == "Monday"){
                            vm.disabledDates.days.push(1);
                        }else if(obj[key] == "Tuesday"){
                            vm.disabledDates.days.push(2);
                        }else if(obj[key] == "Wednesday"){
                            vm.disabledDates.days.push(3);
                        }else if(obj[key] == "Thursday"){
                            vm.disabledDates.days.push(4);
                        }else if(obj[key] == "Friday"){
                            vm.disabledDates.days.push(5);
                        }else if(obj[key] == "Saturday"){
                            vm.disabledDates.days.push(6);
                        }
                    });
                }
                vm.disabledDates.dates = [];
                // code for disable holiday dates on calender
                var holidayDates = this.attendance.companyHolidays;
                if(holidayDates !== null){
                    var obj = holidayDates;
                    Object.keys(obj).forEach(function(key) {
                        var date = obj[key].holiday;
                        var day = new Date(date);
                        vm.disabledDates.dates.push(day);
                    });
                }
              var takeSelfie = this.attendance.companySetting.take_selfie;
                if(takeSelfie == "YES") {
                  vm.form.take_selfie = 1;
                } else {
                  vm.form.take_selfie = 0;
                }
            },

            triggerDate(){
                $('#selectedDateHolyDay').click();
            },

            addHoliday(){
                var date = this.form.holiday_date;
                //date formate according pattern
                var formatedDate = moment(date).format('ddd,DD, MMM, YYYY');
                axios.post('api/addCompanyHoliday', {value:formatedDate})
                    .then(res => {
                        if(res.status == 200){
                            if(res.data == ''){
                                this.showAlertBox('error', 'Given date already marked as holiday')
                            }else{
                                EventBus.$emit('refreshAttendance', res);
                                this.$Progress.finish();
                                toast.fire({
                                    type: 'success',
                                    title: 'Holiday has been updated'
                                });
                            }

                        }else{
                            this.$Progress.fail();
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        swal.fire({
                            type: 'error',
                            title: 'System Not Responding Please Try Again'
                        });
                    });
            },

            checkActive : function(){
                $('.selectpicker').selectpicker('refresh');
                this.isActive = !this.isActive;
            },

            checkDays(day){
                this.$Progress.start();
                this.formObj.key = "off_days";
                if(this.form.selected_days.includes(day)){
                    for (var i = 0; i < this.form.selected_days.length; i++)
                        if (this.form.selected_days[i] === day) {
                            this.form.selected_days.splice(i, 1);
                            break;
                        }
                    this.formObj.value = null;
                    this.formObj.value = JSON.stringify(this.form.selected_days);
                    this.updateSetting();
                }else{
                    this.form.selected_days.push(day);
                    this.formObj.value = JSON.stringify(this.form.selected_days);
                    this.updateSetting();
                }
            },
            takeSelfie($event){
              this.formObj.key = $event.target.value;
              if($event.target.checked) {
                this.formObj.value = 'YES';
              } else {
                this.formObj.value = 'NO';
              }
              this.updateSetting();
            },
            updateAttendanceSetting($event){
                this.formObj.key = $event.target.name;
                this.formObj.value = $event.target.value;
                this.updateSetting();
            },

            updateSetting(){
                this.$Progress.start();
                axios.post('api/updateAttendanceSetting', this.formObj)
                    .then(res => {
                        if(res.status == 200){
                            EventBus.$emit('refreshAttendance', '');
                            this.$Progress.finish();
                            this.showToastBox('success','Attendance setting has been updated');
                        }else{
                            this.$Progress.fail();
                        }

                    })
                    .catch(err => {
                        this.$Progress.fail();
                        this.showAlertBox('error','Some problem in your form data');
                    });
            },

            deteleHoliday(id){
                this.$Progress.start();
                swal.fire({
                        title: 'Are you sure?',
                        text: "",
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonColor: '#3085d6',
                        cancelButtonColor: '#d33',
                        confirmButtonText: 'Yes, delete it!',
                        cancelButtonText: 'No, cancel!',
                        reverseButtons: true
                    }).then((result) => {
                        if (result.value) {
                            axios.post('api/deleteCompanyHoliday', {value:id})
                            .then(res => {
                                if(res.status == 200){
                                    EventBus.$emit('refreshAttendance', '');
                                    this.showToastBox('success', 'Holiday has been updated')
                                }else{
                                    this.$Progress.fail();
                                    this.showAlertBox('error','Some problem in your form data');
                                }
                            })
                            .catch(err => {
                                this.$Progress.fail();
                                this.showAlertBox('error','Some problem in your form data');
                            });
                        } else if (result.dismiss === Swal.DismissReason.cancel){
                            this.$Progress.fail();
                            swal.fire(
                                'Cancelled',
                                'Your decision has been cancelled',
                                'error'
                            )
                        }
                    })
            },

        },

        destroyed: function() {
            EventBus.$off('attendanceObject');
        },
    }
</script>
